// Legacy frontend admins retained for backward compatibility.
export const MOTIVISION_ADMINS = [
  '392396aa-2ae1-4082-86f2-6c330f8c9299', // Omri 1
  '8f8b08ee-0cbb-4dbb-82d9-ad3b3b93a858', // Omri 2
  'd73dc1ea-5842-458d-9f47-370c1dd79ccd', // Noam 1
  '08fead3f-5cca-4d99-a782-101d3848980f', // Noam 2
  '352feed8-e2ff-423c-931f-7712fcd3b61f', // Daniel 1
  'ac2f29a5-44c3-4f6d-b1b7-c7d731aee5bf', // Vishrut Jha
  '1ddcc87e-4ca4-4525-bf87-882d86ad14a8', // Akshay
  'eaec2ade-e47b-40b2-a6c5-1c226079d072', // Adithya
];
